<!--
 * @Version      : V1.0
 * @Date         : 2025-05-21 13:27:18
 * @fileName     :
 * @Description  : 供应商付款申请详情
-->
<template>
  <el-drawer :title="title" v-loading="loading" :visible.sync="dialogDrawer" direction="rtl" :wrapperClosable="false"
    size="80%" :before-close="closeDrawer">
    <div class="details px-20 py-20 border-box">
      <el-row :gutter="20">
        <el-col :span="18">
          <descriptions v-if="!showDesc" :status="status" :row-data="rowData" :columns="columns" :span="2"
            :rules="rules" ref="descriptionsRef"></descriptions>
          <auditCom v-if="toExamine && dialogDrawer" @refreshInitData="childReviewer"></auditCom>
        </el-col>
        <el-col :span="6">
          <div class="approval-progress">
            <div class="progress-box"  v-if="status !== 'add'">
              <div class="progress-title">审批流程</div>
              <div class="progress-desc-info flex flex-wrap">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item v-for="(item, index) in processDescInfo" :key="index">
                    <div class="items">
                      <el-avatar shape="square" size="large"
                          :src="item ? imageUrlprefix + item : defaultAvatar"></el-avatar>
                    </div>
                  </el-breadcrumb-item>
                </el-breadcrumb>
              </div>
            </div>
            <div class="progress-title" v-if="status !== 'add'">审批进度</div>
            <div class="progress-con" v-if="status !== 'add'">
              <el-timeline>
                <el-timeline-item v-for="(item, index) in processList" :key="index" size="large"
                  :icon="auditProcessStatus(item.auditStatus).icon" :color="auditProcessStatus(item.auditStatus).color">
                  <el-row :gutter="15">
                    <el-col :span="6">
                      <div>
                        <el-image v-if="item.typeLabel == '抄送人'" style="width: 40px;height: 40px;" :src="require('@/assets/makeACopyFor.png')" fit="cover"></el-image>
                        <el-avatar shape="square" v-else size="large"
                          :src="item.avatar ? imageUrlprefix + item.avatar : defaultAvatar"></el-avatar>
                      </div>
                    </el-col>
                    <el-col :span="18" v-if="item.typeLabel=='抄送人'">
                      <div class="makeACopyFor-desc">
                        <div class="makeACopyFor-title">
                          {{ item.typeLabel }}
                        </div>
                        <div class="makeACopyFor-num">
                          已抄送{{ item.userList? item.userList.length:0}}人
                        </div>
                        <div class="makeACopyFor-box flex justify-start items-center flex-wrap">
                          <div class="child-items" v-for="(cItem,cIndex) in item.userList" :key="cIndex">
                            <el-avatar shape="square" size="large"
                            :src="cItem.userAvatar ? imageUrlprefix+cItem.userAvatar : defaultAvatar"></el-avatar>
                            <div class="child-text">{{ cItem.userName }}</div>
                          </div>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="18" v-else>
                      <div class="progress-desc">
                        <div><span>{{ item.name }}</span><span class="progress-time">{{ item.date }}</span></div>
                        <div>{{ item.typeLabel }}</div>
                        <div :style="{ color: auditProcessStatus(item.auditStatus).color, fontSize: '18px' }">{{
                          item.auditLabel }}</div>
                        <div class="signature-box flex justify-start items-center" v-if="item.signatureUrl">
                          <span class="signature-title">签名</span>
                          <el-image class="signature-img" :src="imageUrlprefix+item.signatureUrl" fit="contain"></el-image>
                        </div>
                        <el-tooltip class="item" effect="dark" :content="item.auditComment" placement="top-start">
                          <p class="notes-text" v-if="item.auditStatus == 2 || item.auditStatus == 9 || item.auditStatus == 9">
                            {{ item.auditComment }}
                          </p>
                        </el-tooltip>
                      </div>
                    </el-col>
                  </el-row>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="details-footer px-20 py-20 border-box" v-if="status !== 'view'">
      <el-button type="primary" @click="submit()">提交</el-button>
      <el-button type="primary" @click="temporarilyStore()" v-if="status == 'add' || status == 'edit'">暂存</el-button>
      <el-button @click="clearForm()" v-if="status == 'add' || status == 'edit'">清空</el-button>
    </div>
  </el-drawer>
</template>

<script>


import descriptions from '@/components/descriptions/index.vue'
import { queryFinMakePaymentSupDetailsApi, addFinMakePaymentSupApi, editFinMakePaymentSupApi, processFinMakePaymentSupApi, reAddFinMakePaymentSupApi,queryAuditProcessDescriptionApi } from '@/api/supplierPay/index'
import { queryBasicSuppliersListApi, queryBasicOwnersListApi } from '@/api/basicInfo/index'
import { auditProcessStatus } from '@/utils/index'
import auditCom from "@/components/auditCom/index.vue"
export default {
  components: {
    descriptions,
    auditCom
  },
  props: {
    toExamine: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '付款申请详情'
    },
    status: {
      type: String,
      default: 'view'
    }
  },
  data() {
    return {
      defaultAvatar: 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png',
      dialogDrawer: false,
      loading: false,
      customerForm: {},
      showDesc: false,
      columns: [
        { key: 'makePaymentName', label: '付款申请名称', span: 2, placeholder: '客户名称+业务描述', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'supplierId', label: '供应商', span: 6, placeholder: '选择供应商', input: 'select', type: 'text', disabled: true, defaultValue: '', option: [], labelKey: 'supplierName', valueKey: 'id' },
        { key: 'ownerId', label: '付款单位', span: 3, placeholder: '请选择我方单位', input: 'select', type: 'text', disabled: true, defaultValue: '', option: [], labelKey: 'unitName', valueKey: 'id' },
        { key: 'paymentStartDate', label: '付款期限开始', span: 1, placeholder: '请选择付款期限开始', input: 'date', type: '', disabled: true, defaultValue: '' },
        { key: 'paymentEndDate', label: '付款期限结束', span: 1, placeholder: '请选择付款期限结束', input: 'date', type: '', disabled: true, defaultValue: '' },
        { key: 'paymentAmount', label: '本次付款金额(元)', span: 1, placeholder: '请输入本次付款金额', input: 'input-number', type: 'text', disabled: true, defaultValue: '', amountCn: true, amountKeyName: 'paymentAmountCn' },
        { key: 'paymentAmountCn', label: '金额大写', span: 1, placeholder: '请输入金额大写', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'attachment', height: '450px', label: '附件', span: 2, placeholder: '请上传附件上传', uploadType: 'project', input: 'upload', fileMaxSize: 20, disabled: true, defaultValue: [], accept: '.xls,.xlsx,.pdf,.doc,.docx,.txt,.bmp,.jpg,.jpeg,.png,.tif,.gif,.svg,.webp,.zip,.rar,.7z', limit: 50, },
        { key: 'notes', label: '备注', span: 2, placeholder: '请输入备注', input: 'textarea', type: 'textarea', disabled: true, defaultValue: '' },
      ],
      rowData: {},
      cloneColumns: [],//复制一遍
      rules: {
        makePaymentName: [
          { required: true, message: '请输入供应商付款申请名称', trigger: 'blur' },
        ],
        supplierId: [
          { required: true, message: '请选择供应商', trigger: 'blur' }
        ],
        ownerId:[{ required: true, message: '请选择付款单位', trigger: 'blur' }],
        paymentAmount:[{ required: true, message: '请输入本次付款金额', trigger: 'blur' }],
        paymentAmountCn:[{ required: true, message: '请输入金额大写', trigger: 'blur' }],
        paymentStartDate: [
          { type: 'string', required: true, message: '请选择付款期限开始', trigger: 'blur' }
        ],
        paymentEndDate: [
          { type: 'string', required: true, message: '请选择付款期限结束', trigger: 'blur' }
        ],
        
      },
      processList: [],
      processDescInfo:[]
    }
  },
  mounted() {
    this.getOwnersList();
    this.getBasicSuppliersList()
    this.cloneColumns = JSON.parse(JSON.stringify(this.columns))
  },
  methods: {
    auditProcessStatus,
    //核心方法 判断是否是新增 还是编辑
    async openDrawer(row) {
      this.dialogDrawer = true;
      this.$nextTick(() => {
        switch (this.status) {
          case 'view':
            this.queryDetails({ id: row.id })
            break;
          case 'add':
            //新增把原有的数据设置默认值
            this.showDesc = true;
            for (let i = 0; i < this.columns.length; i++) {
              this.columns[i].disabled = false;
              this.columns[i].defaultValue = this.cloneColumns[i].defaultValue;
            }
            this.$nextTick(() => {
              this.showDesc = false;
            })
            break;
          case 'edit':
            this.queryDetails({ id: row.id })
            break;
          case 'change':
            this.queryDetails({ id: row.id })
            break;
          case 'reAdd':
            this.queryDetails({ id: row.id })
            break;
          default:
            break;
        }
      })
    },
    //关闭弹框
    closeDrawer() {
      this.dialogDrawer = false;
    },
    //详情查询
    queryDetails(params) {
      this.loading = true;
      this.showDesc = true;
      queryFinMakePaymentSupDetailsApi(params).then(res => {
        this.loading = false;
        this.showDesc = false;
        if (res.code == 200) {
          this.rowData = res.data;
          if (this.status !== 'add') {
            for (let i = 0; i < this.columns.length; i++) {
              this.columns[i].disabled = this.status == 'view' ? true : false;
              this.columns[i].defaultValue = this.rowData[this.columns[i].key];
            }
          }
        }
      })
      this.queryProcessProject(params)
      this.qeuryAuditProcessDescription(params)
    },
    //提交
    submit(status = 1) {
      this.$refs.descriptionsRef.submit().then(formData => {
        let params = {
          makePaymentStatus: status,
          ...formData
        }
        this.loading = true;
        if (this.status == 'add') {
          addFinMakePaymentSupApi(params).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
            this.loading = false;
            this.closeDrawer();
            this.queryData();
          })
        } else if (this.status == 'reAdd') {
          reAddFinMakePaymentSupApi(params).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            }
            this.loading = false;
            this.closeDrawer();
            this.queryData();
          }).catch(err => {
            this.loading = false;
          })
        } else {
          editFinMakePaymentSupApi(params).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            }
            this.loading = false;
            this.closeDrawer();
            this.queryData();
          }).catch(err => {
            this.loading = false;
          })
        }

      })
    },
    //暂存
    temporarilyStore() {
      this.submit(0);
    },
    //清空描述组件form
    clearForm() {
      this.$refs.descriptionsRef.resetForm()
    },
    //查询列表
    queryData() {
      this.$emit('initQueryData')
    },
    
    //我方负责单位下拉
    getOwnersList() {
      let params = {
        unitName: ""
      }
      queryBasicOwnersListApi(params).then(res => {
        if (res.code == 200) {
          this.columns.map(item => {
            if (item.key == 'ownerId') {
              item.option = res.data || []
            }
            return item
          })
        }
      })
    },
    //供应商下拉
    getBasicSuppliersList() {
      let params = {
        supplierName: ''
      }
      queryBasicSuppliersListApi(params).then(res => {
        if (res.code == 200) {
          this.columns.map(item => {
            if (item.key == 'supplierId') {
              item.option = res.data || []
            }
            return item
          })
        }
      })
    },
    queryProcessProject(params) {
      processFinMakePaymentSupApi(params).then(res => {
        if (res.code == 200) {
          this.processList = res.data;
        }
      })
    },
    qeuryAuditProcessDescription(params){
      queryAuditProcessDescriptionApi(params).then(res=>{
        if(res.code==200){
          this.processDescInfo = res.data.avatars;
        }
      })
    },
    //打开审核框
    childReviewer(row) {
      this.closeDrawer()
      this.$emit('parReviewer')
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-drawer__header {
  color: #000;
  font-size: 18px;
}
::v-deep .el-breadcrumb__separator{
  color: #000;
}
::v-deep .el-breadcrumb__separator{
  color: #000;
}
.details-footer {
  height: 50px;
  line-height: 50px;
  text-align: right;
}

.progress-box{
  padding: 5px;
  box-sizing: border-box;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  border-radius: 5px;
  margin-bottom: 5px;
  background: #285af1;
  .progress-title {
    font-size: 18px;
    padding-bottom: 10px;
    color: #fff;
  }
  .progress-desc-info {
    padding: 10px 0px 10px 0px;

    .items {
      font-size: 15px;
      display: inline-block;
      vertical-align: middle; 
    }
  }
}
.approval-progress {
  .progress-desc-info{
    padding:10px 0px 10px 0px;
    .items{
      font-size: 15px;
      color: #285af1;
    }
  }
  .progress-title {
    font-size: 18px;
    padding-bottom: 10px;
  }

  .progress-con {
    .progress-desc {
      line-height: 20px;
      color: #303133;
      .progress-time {
        margin-left: 10px;
        color: #909399;
      }
      .notes-text{
        display: -webkit-box;               /* 设置为弹性盒子模型 */
        -webkit-box-orient: vertical;       /* 垂直排列 */
        -webkit-line-clamp: 2;              /* 显示最多 3 行 */
        overflow: hidden;                   /* 隐藏超出的部分 */
        text-overflow: ellipsis;            /* 使用省略号 */
      }
      .signature-box {
        width: 180px;
        height: 50px;
        overflow: hidden;
        .signature-title{
          display: block;
          width: 40px;
        }
        .signature-img {
          margin-left: 10px;
          width: 180px;
        }
      }
    }
    .makeACopyFor-desc{
       line-height: 20px;
      color: #303133;
      .makeACopyFor-title{

      }
      .makeACopyFor-num{
        color: #909399;
      }
      .makeACopyFor-box{
        .child-items{
          padding-right: 5px;
          box-sizing: border-box;
          .child-text{
            text-align: center;
          }
        }
      }
    }
  }
}

</style>
